import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "type", "disabled"]

import { reactive, ref, onMounted, computed } from "vue";

    const defaultClassesList = "justify-content-center";
    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomButton',
  props: {
    type: {},
    loading: { type: Boolean },
    disabled: { type: Boolean },
    classesList: {},
    id: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const emit = __emit
    const props = __props;
    const computedClassesList = computed(() => {
        let classes = defaultClassesList;
        if (props.classesList) { classes = `${classes} ${props.classesList}`; }
        return classes;
    });
    const computedType = computed(() => props.type ?? "button");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    id: props.id,
    type: computedType.value,
    class: _normalizeClass([ computedClassesList.value, props.loading ? 'loading' : '']),
    disabled: props.loading || props.disabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["btn-show", {'display-none': props.loading}])
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _cache[1] || (_cache[1] = _createTextVNode("Button", -1))
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["btn-loading", {'display-none': !props.loading}])
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("div", { class: "loader-dots" }, null, -1)
    ]))], 2)
  ], 10, _hoisted_1))
}
}

})